import styled, { keyframes } from 'styled-components';
import { PlaceholderStyleProps } from './Placeholders.interface';

const slideTop = keyframes`
    from {
        opacity: .3;
    }
    to {
        opacity: 0;
    }
`;

export const Wrapper = styled.div<PlaceholderStyleProps>`
    width: 940px;
    height: 44px;
    margin: 0 auto ${({ theme }) => theme.spacing * 3}px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.primary};
    opacity: ${(props) => props.opacity};
    animation: ${slideTop} .6s ${(props) => props.opacity * 2}s linear infinite;
    @media screen and (max-width: 690px) {
        width: calc(100% - 32px);
        height: 100px;
        box-sizing: border-box;
        margin: ${({ theme }) => theme.spacing * 3}px ${({ theme }) => theme.spacing * 4}px;
    }
`;
